import * as actionTypes from '../config/actionTypes';
import * as forms from './forms';


const initialState = {
  token: null,
  user: null,
  loginForm: forms.loginForm,
  passwordResetForm: forms.passwordResetForm,
  setPasswordForm: forms.setPasswordForm,
  loading: false,
  hasError: false,
  errors: [],
  success: null,
};


const authLogout = (state) => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  return {
    ...state,
    token: null,
    user: null,
  };
};


const storeAuthDataReducer = (state, payload) => {
  return {
    ...state,
    token: payload.token,
    user: payload.user,
  };
};


const printSuccessMsgReducer = (state, payload) => {
  return {
    ...state,
    success: payload,
  };
};


const updateAuthInputsReducer = (state, payload) => {
  return {
    ...state,
    [payload.form]: {
      ...state[payload.form],
      ...payload.data,
    },
  };
};


const toggleAuthLoadingReducer = (state) => {
  return {
    ...state,
    loading: !state.loading,
  };
};


const toggleAuthErrorReducer = (state) => {
  return {
    ...state,
    hasError: !state.hasError,
  };
};


const updateAuthErrorsReducer = (state, payload) => {
  return {
    ...state,
    errors: payload,
  };
};


const onUnmountReducer = (state) => {
  return {
    ...state,
    loading: false,
    hasError: false,
    errors: [],
    success: null,
  };
};


const resetAuthForm = (state, payload) => {
  return {
    ...state,
    [payload]: { ...initialState[payload] },
  };
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_LOGOUT: return authLogout(state);
    case actionTypes.STORE_AUTH_DATA: return storeAuthDataReducer(state, action.payload);
    case actionTypes.UPDATE_AUTH_INPUTS: return updateAuthInputsReducer(state, action.payload);
    case actionTypes.TOGGLE_AUTH_LOADING: return toggleAuthLoadingReducer(state);
    case actionTypes.TOGGLE_AUTH_ERROR: return toggleAuthErrorReducer(state);
    case actionTypes.UPDATE_AUTH_ERRORS: return updateAuthErrorsReducer(state, action.payload);
    case actionTypes.PRINT_SUCCESS_MSG: return printSuccessMsgReducer(state, action.payload);
    case actionTypes.AUTH_UNMOUNT: return onUnmountReducer(state);
    case actionTypes.RESET_AUTH_FORM: return resetAuthForm(state, action.payload);
    default:
      return state;
  }
};


export default reducer;



// WEBPACK FOOTER //
// ./src/auth/reducers.js